import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BsPlus } from "react-icons/bs";
import List from "./List";
import * as UIcons from '@iconscout/react-unicons'
import { IOSSwitch } from "components/IOSSwitch";
import { MovieT } from "../type";
import { useNavigate } from "react-router-dom";

// Columns
const columns = [
    { key: "title", label: "Title" },
    { key: "fileSize", label: "File size" },
    { key: "duration", label: "Duration" },
    { key: "status", label: "Status", render: () => <IOSSwitch /> },
];



export const Trailers = ({ movie }: { movie: MovieT }) => {
    const AccordionStyle = {
        '&:before': {
            backgroundColor: 'transparent !important',
        },

    };
    const navigate = useNavigate();
    return (
        <Accordion elevation={0} className="rounded-2xl rounded-t-2xl mb-4 border" sx={AccordionStyle}>
            <AccordionSummary
                sx={{ border: 'none' }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"

            >
                <div className="!flex !justify-between items-center w-full">
                    <h2 className="text-xl font-bold text-black text-left">Trailers</h2>

                    <div className="border rounded-md w-10 h-10 flex items-center justify-center mr-4">
                        <BsPlus size={30} />
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>

                <Divider sx={{ borderStyle: 'dashed' }} className="mb-3" />

                <List columns={columns} data={movie?.trailers?.map(trailer => ({
                    id: trailer?.id,
                    title: trailer?.name,
                    fileSize: trailer?.size,
                    duration: trailer?.duration,
                    status: movie?.status,
                    trailer,
                }))} numbered fullSpanKey="name" actions={[
                    { title: 'View details', onClick: (row) => { navigate(`/movie-box/${movie?.id}/trailers/${row?.trailer?.id || row?.id}`, { state: { trailer: row?.trailer } }); }, icon: <UIcons.UilInfoCircle className="text-black" />, className: 'text-black' },
                    { title: 'Edit', onClick: (row) => { navigate(`/movie-box/${movie?.id}/trailers/${row?.trailer?.id || row?.id}/edit`, { state: { trailer: row?.trailer } }); }, icon: <UIcons.UilPen className="text-black" />, className: 'text-black' },
                    { title: 'Move to archive', onClick: (row) => { /* implement archive */ }, icon: <UIcons.UilDownloadAlt className="text-red-600" />, className: 'text-red-600' },
                ]} />
            </AccordionDetails>
        </Accordion>
    )
}
